/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{mix as e}from"../../utils/mix.js";import{complex as r}from"../../value/types/complex/index.js";const t={correct:(t,{treeScale:o,projectionDelta:n})=>{const c=t,s=r.parse(t);if(s.length>5)return c;const m=r.createTransformer(t),p="number"!=typeof s[0]?1:0,a=n.x.scale*o.x,l=n.y.scale*o.y;s[0+p]/=a,s[1+p]/=l;const f=e(a,l,.5);return"number"==typeof s[2+p]&&(s[2+p]/=f),"number"==typeof s[3+p]&&(s[3+p]/=f),m(s)}};export{t as correctBoxShadow};
//# sourceMappingURL=scale-box-shadow.js.map
